import UpdateFormHead from "components/subHead/updateFromHead";
import LodChlSelect from "components/select/lod/lodChl";
import RmNmSelect from "components/select/rm/rmNo";
import RmOpNmSelect from "components/select/rm/rmOpNm";
import { CREATE_FORM_ID_ROOM_PRODUCT } from "components/constent";
import DatePick from "components/datePick";
import TableRow from "components/rows/tableRow";
import LodInfRow from "components/rows/lodRow";
import { days } from "components/utils/option";
import { lngProps } from "interface/index";
import i18n from "locales/i18n";
import { useTranslation } from "react-i18next";
import { useBaseSubmitForm } from "./service";

import Cell from "components/rows/cell";
import { priceFormat, regNum, timeFormat } from "components/utils/comm";
import { useCreatePrudoctParamContext } from "./context";

export default function ProductCreate() {
  const { t } = useTranslation();
  const langCd = i18n.language;

  const { rmInf, opInf, param, onChange, onSelect, onPickDate, onReset } =
    useCreatePrudoctParamContext();

  const { onBaseSubmit } = useBaseSubmitForm();

  const dayArr = days.sort((a: any, b: any) => {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  return (
    <>
      <UpdateFormHead
        title={t("row_ttl_default")}
        sub={t("sub_require")}
        formId={CREATE_FORM_ID_ROOM_PRODUCT}
        btnTxt={t("txt_create")}
      />

      <form
        id={CREATE_FORM_ID_ROOM_PRODUCT}
        onSubmit={onBaseSubmit}
        onReset={onReset}
      >
        <table>
          <tbody>
            <LodInfRow />
            <TableRow title={"객실정보"}>
              <ul>
                <li>
                  <label htmlFor="dot">{t("lbl_rm_nm")}</label>
                  <RmNmSelect
                    required
                    isFullInf
                    isReset={!param.rmNo}
                    select={(option) => {
                      onSelect("rmNo", option);
                    }}
                  />
                </li>
                <li>
                  <label>{t("lbl_rm_typ")}</label>
                  <input
                    type="text"
                    value={rmInf?.rmTypNm ?? ""}
                    data-type="R"
                    readOnly
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_rm_olk")}</label>
                  <input
                    type="text"
                    value={rmInf?.rmOlkNm ?? ""}
                    data-type="R"
                    readOnly
                  />
                </li>
              </ul>
            </TableRow>
            <TableRow title={t("row_ttl_rm_op_inf")}>
              <ul>
                <li>
                  <label htmlFor="dot">{t("lbl_rm_op")}</label>
                  <RmOpNmSelect
                    required
                    isFullInf
                    isReset={!param.rmOpSeq}
                    select={(option) => {
                      onSelect("rmOpSeq", option);
                    }}
                    rmNo={rmInf?.rmNo ?? ""}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_brkf")}
                    value={
                      opInf?.brkfInYn === "Y"
                        ? t("included_y")
                        : opInf?.brkfInYn === "N"
                        ? t("included_n")
                        : ""
                    }
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_lat_out_ti")}</label>
                  <input
                    type="text"
                    value={timeFormat(opInf?.latChkOutTi || "")}
                    data-type="R"
                    readOnly
                  />
                </li>
              </ul>
            </TableRow>
            <TableRow title={"상품정보"}>
              <ul>
                <li>
                  <label htmlFor="dot">{t("lbl_rmpd_ct")}</label>
                  <input
                    type="text"
                    name="rmPdCt"
                    required
                    data-type="C"
                    value={param?.rmPdCt ?? ""}
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.currentTarget.value.replace(/[₩,]/g, "");
                      if (!regNum.test(value)) {
                        return (e.currentTarget.value = "");
                      }

                      onChange("rmPdCt", value);
                    }}
                    onInvalid={(e) =>
                      e.currentTarget.setCustomValidity(
                        "상품수량을 입력하여 주세요."
                      )
                    }
                    onInput={(e) => e.currentTarget.setCustomValidity("")}
                  />
                </li>
                <li>
                  <label htmlFor="dot">{t("lbl_rmpd_chl")}</label>
                  <LodChlSelect
                    required
                    isReset={!param.lodChlCd}
                    select={(option) => onSelect("lodChlCd", option)}
                  />
                </li>
                <li>
                  <label htmlFor="dot">{t("lbl_rmpd_price")}</label>
                  <input
                    type="text"
                    name="rmPdSellPri"
                    required
                    data-type="C"
                    value={param?.rmPdSellPri ?? ""}
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.currentTarget.value.replace(/[₩,]/g, "");
                      if (!regNum.test(value)) {
                        return (e.currentTarget.value = "");
                      }
                      const price =
                        priceFormat({ price: value, currSymbol: false }) || "";
                      onChange("rmPdSellPri", price);
                    }}
                    onInvalid={(e) =>
                      e.currentTarget.setCustomValidity(
                        "상품금액을 입력하여 주세요."
                      )
                    }
                    onInput={(e) => e.currentTarget.setCustomValidity("")}
                  />
                </li>
                <li>
                  <DatePick
                    txt={t("lbl_s_e_dt")}
                    startNm={"rmPdSDt"}
                    endNm={"rmPdEDt"}
                    defaultValue={[param?.rmPdSDt, param?.rmPdEDt]}
                    onPickDate={onPickDate}
                  />
                </li>
              </ul>
              <ul>
                <li>
                  <label htmlFor="" className="">
                    {t("lbl_day")}
                  </label>
                  <div className="flex w-[60%]">
                    {dayArr.map((day) => {
                      return (
                        <div key={day.value} className="flex items-center">
                          <input
                            type="checkbox"
                            // name={`day_${day.value}`}
                            name={day.value}
                            id={day.value}
                            defaultChecked
                            data-type="C"
                            onChange={(e) => {
                              const index = Number(e.currentTarget.name);
                              const checked = e.currentTarget.checked;
                              const value = checked ? "Y" : "N";
                              let rmPdAplyDow = param?.rmPdAplyDow;
                              rmPdAplyDow =
                                rmPdAplyDow?.slice(0, index) +
                                value +
                                rmPdAplyDow?.slice(index + 1);

                              onChange("rmPdAplyDow", rmPdAplyDow);
                            }}
                          />
                          <label htmlFor={day.value} className="w-[40px]">
                            {day[langCd as keyof lngProps]}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      </form>
    </>
  );
}
